import React from 'react'
import { useTrans } from 'hooks'
import { PaginaNode } from '@gql/graphql'
import { PlaceholderReact, SizeTable } from '@components/molecules'
import { AcquistiOnlineLayout, Page } from 'components/organisms'
import styles from './GuidaBarreCateneTemplate.module.sass'

interface Props {
  pagina?: PaginaNode
  mainContent?: any
}

const GuidaBarreCateneTemplate = (props: Props) => {
  const { pagina, mainContent } = props

  const t = useTrans()

  const tablePassoRows = [
    ['1/4"', '6,35'],
    ['.325"', '8,25'],
    ['3/8"', '9,52'],
  ].map((x) =>
    x.map((y, i) => ({
      type: i === 0 ? ('header' as 'header') : undefined,
      content: <>{y}</>,
    }))
  )

  const tableSpessoreRows = [
    ['.043”', '1,09'],
    ['.050”', '1,27'],
    ['.058”', '1,47'],
    ['.063”', '1,6'],
  ].map((x) =>
    x.map((y, i) => ({
      type: i === 0 ? ('header' as 'header') : undefined,
      content: <>{y}</>,
    }))
  )

  const tableCompatibilitaRows = [
    ['1/4', '.043"', 'MICRO-CHISEL', '90°', '30°', '.025"', '85°-90°', '60°', '5/32" - 4.00 mm'],
    ['1/4', '.050"', 'MICRO-CHISEL', '90°', '30°', '.025"', '85°-90°', '60°', '5/32" - 4.00 mm'],
    ['3/8 LP', '.043"', 'SEMI-CHISEL', '30°', '35°', '.025"', '85°-90°', '60°', '5/32" - 4.00 mm'],
    ['3/8 LP', '.050"', 'SEMI-CHISEL', '30°', '35°', '.025"', '85°-90°', '60°', '5/32" - 4.00 mm'],
    ['.325', '.050"', 'SEMI-CHISEL', '90°', '30°', '.025"', '85°-90°', '60°', '3/16" - 4.8 mm'],
    ['.325', '.058"', 'SEMI-CHISEL', '80°', '30°', '.025"', '80°-90°', '60°', '11/64" - 4.5 mm'],
    ['.325', '.058"', 'CHISEL 72', '90°', '30°', '.025"', '80°-90°', '60°', '3/16" - 4.8 mm'],
    ['3/8', '.043"', 'MICRO-CHISEL', '90°', '35°', '.025"', '85°-90°', '60°', '7/32" - 5.5 mm'],
    ['3/8', '.058"', 'PRO-CHISEL', '80°', '30°', '.025"', '80°-90°', '60°', '7/32" - 5.5 mm'],
    ['3/8', '.050"', 'SEMI-CHISEL 50 K', '90°', '35°', '.025"', '85°-90°', '60°', '7/32" - 5.5 mm'],
  ].map((x) =>
    x.map((y, i) => ({
      type: i === 0 ? ('header' as 'header') : undefined,
      content: <>{y}</>,
    }))
  )

  return (
    <Page pagina={pagina} className={styles.root}>
      <AcquistiOnlineLayout pagina={pagina}>
        <div className={styles.scope}>
          <div className={styles.list}>
            <section className={styles.item}>
              <div className={styles.pbWrap}>
                <PlaceholderReact
                  contentTypeId={pagina.model}
                  objectId={pagina.pk}
                  pkey="main"
                  serverSideContent={mainContent}
                />
              </div>
              <div className={styles.tableGrid}>
                <SizeTable
                  className={styles.tableBase}
                  headers={[
                    { label: t('Passo catena in pollici') },
                    { label: t('Passo catena in millimetri') },
                  ]}
                  rows={tablePassoRows}
                />
                <p className={styles.tableNote}>
                  <strong>{t('Spessore della catena')}:</strong>{' '}
                  {t(
                    'basta misurare, con l’ausilio del calibro, lo spessore delle maglie di trascinamento inferiori.'
                  )}
                </p>
                <SizeTable
                  className={styles.tableBase}
                  headers={[
                    { label: t('Spessore catena in pollici') },
                    { label: t('Spessore catena in millimetri') },
                  ]}
                  rows={tableSpessoreRows}
                />
              </div>
              <SizeTable
                headers={[
                  { label: t('Passo (Pitch)') },
                  { label: t('Spessore (Gauge)') },
                  { label: t('Tipologia') },
                  { label: t('Affilatura dente') },
                  { label: t('Angolo affilatura superiore') },
                  { label: t('Profilo del dente') },
                  { label: t('Angolo piastra laterale') },
                  { label: t('Altezza delimitatore profondità') },
                  { label: t('Diametro lima') },
                ]}
                rows={tableCompatibilitaRows}
                className={styles.compatibilityTable}
              />
            </section>
          </div>
        </div>
      </AcquistiOnlineLayout>
    </Page>
  )
}

export default GuidaBarreCateneTemplate
